import { GlobalSettingEnum } from 'api/model';
import Roles, { includesRoles } from 'constants/Roles';
import useMe from 'contexts/authentication/useMe';
import useGlobalSettings from './useGlobalSettings';

/**
 * Returns true when the current user should see the EXACT TB amount next to the worded TB class
 * in Ruttplanering (a neutral "TB ≈ 900 kr · +16 %" badge beside "God marginal").
 *
 *  - SuperAdmin always sees it (for verification before flipping the flag).
 *  - Everyone else sees it only when RoutePlanAbsoluteTbEnabled is on.
 *
 * No role policy beyond that: the page itself is open to every web admin (DefaultWebAdminPolicy),
 * so anyone rendering a package card belongs there. And nothing is hidden by this hook — the full breakdown (revenue, cost, TB, and what
 * makes each uncertain) is in the chip's tooltip for every user. The flag buys glanceability,
 * not access, which is why there is no backend gate to mirror: RevenueSek/CostSek/TbBufferPercent
 * ship in the route-planning DTOs regardless.
 */
const useHasAccessToAbsoluteTb = (): boolean => {
  const me = useMe();
  const { parsedData } = useGlobalSettings();

  if (!me?.roles) return false;

  if (includesRoles([Roles.SuperAdmin], me.roles)) return true;

  return parsedData[GlobalSettingEnum.RoutePlanAbsoluteTbEnabled] === true;
};

export default useHasAccessToAbsoluteTb;
